export default Object.freeze({
  KEINE: {text: 'keine', value: 'KEINE'},
  TEILWEISE: {text: 'teilweise', value: 'TEILWEISE'},
  VOLL: {text: 'voll', value: 'VOLL'},
  objects: function () {
    return [this.KEINE, this.TEILWEISE, this.VOLL];
  },
});
